'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSupervisorAccount = function MdSupervisorAccount(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 21.6c1.1 0 2.5 0.2 4 0.5-3.4 1.9-4 4.4-4 5.8v3.7h-11.6v-4.1c0-3.9 7.7-5.9 11.6-5.9z m12.5 1.8c3 0 9.1 1.4 9.1 4.5v3.7h-18.2v-3.7c0-3.1 6.1-4.5 9.1-4.5z m-12.5-5c-2.7 0-5-2.3-5-5s2.3-5 5-5 5 2.2 5 5-2.3 5-5 5z m12.5 1.6c-2.3 0-4.1-1.9-4.1-4.1s1.8-4.3 4.1-4.3 4.1 2 4.1 4.3-1.8 4.1-4.1 4.1z' })
        )
    );
};

exports.default = MdSupervisorAccount;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/supervisor-account.js
// module id = 3590
// module chunks = 0